const alertGroup = (prefix, options = {}) => {
    const fields = [
        { type: "switch", name: `${prefix}_web_alert`, label: "Web Alert Active", hint: options.webHint },
        { type: "switch", name: `${prefix}_generic_alert`, label: "Generic Alert Active", hint: options.genericHint },
    ];

    if (options.userAlert) {
        fields.push({
            type: "switch",
            name: options.userName || `${prefix}_user_alert`,
            label: "User Alert Active",
            hint: options.userHint,
        });
    }

    if (options.alarmActive) {
        fields.push({
            type: "switch",
            name: options.alarmName || `${prefix}_alarm_active`,
            label: "Alarm Active",
            hint: options.alarmHint,
        });
    }

    if (options.durationPrefix) {
        fields.push({
            type: "time",
            prefix: options.durationPrefix,
            label: "Alarm Duration",
            hint: options.durationHint || "Duration of alarm",
        });
    }

    return fields;
};

export const DOOR_CONFIG_SECTIONS = [
    {
        id: "door",
        title: "Door Configuration",
        icon: "fa-solid fa-door-open",
        fields: [
            {
                type: "switch",
                name: "unlock_switch",
                label: "Unlock Switch Enable",
                hint: "If disable, Door unlock switch will not work.",
            },
            {
                type: "time",
                prefix: "unlock_command_duration",
                label: "Unlock Command Duration",
                hint: "When a door unlock request is triggered, lock will be open within this amount of time. After this time unlock command will be closed.",
            },
            {
                type: "time",
                prefix: "lco_duration",
                label: "Lock open duration",
                hint: "When a door unlock request is triggered, lock will be unlocked for this amount of time. After this time lock will be closed.",
            },
            {
                type: "time",
                prefix: "temp",
                label: "Cabinet Temperature",
                readOnly: [0, 1],
            },
            {
                type: "threshold",
                prefix: "lock_volt_threshold",
                label: "Lock volt Threshold",
            },
            {
                type: "threshold",
                prefix: "card_volt_threshold",
                label: "Card volt Threshold",
            },
        ],
    },
    {
        id: "vibration_sensor",
        title: "Vibration Sensor",
        icon: "fa-solid fa-wave-square",
        fields: [
            {
                type: "time",
                prefix: "max_vib_limit",
                label: "Max Vibration Limit",
                hint: "Vibration alert will be triggered after this amount of vibration count.",
            },
            {
                type: "time",
                prefix: "vib_count_rest_intr",
                label: "Vibration Count Reset Interval",
                hint: "If vibration count does not react at maximum limit, counter will be reset to 0 after this amount of delay.",
            },
            {
                type: "time",
                prefix: "active_delay_close",
                label: "Activation Delay After Close Door",
                hint: "Vibration sensor will be activated this amount of delay after door closed.",
            },
            {
                type: "time",
                prefix: "min_intr_alert",
                label: "Minimum Interval Between Alerts",
                hint: "Once vibration alert is triggered, next vibration alert will not be triggered before this amount of delay.",
            },
        ],
    },
    {
        id: "card_temper",
        title: "Card Temper Protection",
        icon: "fa-solid fa-id-card",
        fields: [
            {
                type: "switch",
                name: "card_temp_pro",
                label: "Card Temper Protection Enable",
                hint: "If false, the card temper protection will be disable.",
            },
            {
                type: "time",
                prefix: "un_auth_card_limit",
                label: "Unauthorized Card Limit",
                readOnly: [0, 1],
                hint: "Maximum unauthorized card insertation limit. System will trigger Card tamper after continues insertation of this amount of unauthorized card.",
            },
            {
                type: "time",
                prefix: "un_auth_card_count_rest",
                label: "Unauthorized Card Count Reset Interval",
                hint: "If unauthorized card insertation does not reaches maximum limit, counter will be reset to 0 after this amount of delay.",
            },
            {
                type: "time",
                prefix: "rfid_reader_lock_intr",
                label: "RFID Reader Lock Interval",
                hint: "If Card Tamper Triggers, RFID Reader will be disabled of this amount of time.",
            },
        ],
    },
    {
        id: "door_unlock_alert",
        title: "Door Unlock Alert",
        icon: "fa-solid fa-unlock",
        fields: [
            ...alertGroup("door_unlock", {
                webHint: "If True, every single door unlock request will create door open alert at web.",
                genericHint: "If True, every single door unlock request will create generic SMS alert.",
                userAlert: true,
                userHint: "If True, door unlocker will received SMS alert.",
                alarmActive: true,
                alarmName: "door_unlock_alrm_active",
                alarmHint: "If True, Alarm will ring at device on door unlock request.",
                durationPrefix: "door_unlock_alarm_duration",
            }),
        ],
    },
    {
        id: "door_close_alert",
        title: "Door Close Alert",
        icon: "fa-solid fa-door-closed",
        fields: alertGroup("door_close", {
            webHint: "If True, every door close will create web alert.",
            genericHint: "If True, every door close will create generic SMS alert.",
            userAlert: true,
            userHint: "If True, last door unlocker user will received door closed SMS alert.",
        }),
    },
    {
        id: "lock_close_fail",
        title: "Lock Close Fail",
        icon: "fa-solid fa-lock",
        fields: [
            ...alertGroup("lock_close", {
                webHint: "If True, Lock Close Fail will trigger Web Alert.",
                genericHint: "If True, Lock close failed will create Generic SMS alert.",
                userAlert: true,
                userHint: "If True, Lock close Fail will trigger User SMS alert.",
                alarmActive: true,
                alarmName: "lock_close_alarm_active",
                alarmHint: "If True, Device alarm will ring on Lock Close Fail Status.",
                durationPrefix: "lock_close_alarm_duration",
            }),
            {
                type: "time",
                prefix: "lock_close_user_notify_delay",
                label: "User Notification Delay",
                hint: "If lock close fail status does not cleared, last door unlocker user will receive notification SMS after this amount of delay.",
            },
            {
                type: "time",
                prefix: "lock_close_web_alert_delay",
                label: "Web Alert Delay",
                hint: "If lock close fail status does not cleared, web alert will be created after this amount of delay.",
            },
            {
                type: "time",
                prefix: "lock_close_generic_delay",
                label: "Generic Notification Delay",
                hint: "If lock close failed status does not cleared, generic notification SMS will be sent after this amount of delay.",
            },
        ],
    },
    {
        id: "lock_fault",
        title: "Lock Fault Alert",
        icon: "fa-solid fa-triangle-exclamation",
        fields: [
            ...alertGroup("lock_fault", {
                webHint: "If True, Lock Fault will trigger Web Alert.",
                genericHint: "If True, Lock Fault will be create Generic SMS alert.",
                userAlert: true,
                userName: "lock_fault_user_active_alert",
                userHint: "If True, last door unlocker user will receive lock fault SMS alert.",
                alarmActive: true,
                alarmName: "lock_fault_alarm",
                alarmHint: "If True, Device alarm will ring on Lock Fault Status.",
                durationPrefix: "lock_fault_alarm_duration",
            }),
            {
                type: "time",
                prefix: "lock_fault_detection_delay",
                label: "Lock Fault Detection Delay",
                hint: "Lock Fault will be triggered if lock power connection disconnected for this amount of time.",
            },
        ],
    },
    {
        id: "security_breach",
        title: "Security Breach",
        icon: "fa-solid fa-shield-halved",
        fields: alertGroup("sb", {
            webHint: "If True, Security Breach will trigger Web Alert.",
            genericHint: "If True, Security Breach will be create Generic SMS alert.",
            userAlert: true,
            userHint: "If True, last door unlocker user will receive Security Breach SMS alert.",
            alarmActive: true,
            alarmName: "sb_alarm_active",
            alarmHint: "If True, Device alarm will ring on Security Breach Status.",
            durationPrefix: "sb_alarm_duration",
        }),
    },
    {
        id: "vibration_alert",
        title: "Vibration Alert",
        icon: "fa-solid fa-bell",
        fields: alertGroup("vib", {
            webHint: "If True, Vibration will trigger Web Alert.",
            genericHint: "If True, Vibration will be create Generic SMS alert.",
            userAlert: true,
            userHint: "If True, last door unlocker user will receive Vibration SMS alert.",
            alarmActive: true,
            alarmName: "vib_alarm_active",
            alarmHint: "If True, Device alarm will ring on Vibration Status.",
            durationPrefix: "vib_alarm_duratio",
        }),
    },
    {
        id: "door_open_timeout",
        title: "Door Open Timeout",
        icon: "fa-solid fa-clock",
        fields: [
            {
                type: "time",
                prefix: "door_open_timeout_open_time_",
                label: "Max Door Open Time",
                hint: "Maximum allowable door open duration. If door is open continuously for the amount of time, Door Open Timeout will be triggered.",
            },
            ...alertGroup("door_open_timeout", {
                webHint: "If True, Door Open Timeout will trigger Web Alert.",
                genericHint: "If True, Door Open Timeout will be create Generic SMS alert.",
                userAlert: true,
                userHint: "If True, last door unlocker user will receive Door Open Timeout notification SMS.",
                alarmActive: true,
                alarmName: "door_open_timeout_alarm_active",
                alarmHint: "If True, Device alarm will ring on Door Open Timeout Status.",
                durationPrefix: "door_open_timeout_alarm_duration",
            }),
            {
                type: "time",
                prefix: "door_open_timeout_notify_delay",
                label: "User Notification Delay",
                hint: "If Door Open Timeout continuously, last door unlocker user will receive notification SMS after this amount of delay.",
            },
            {
                type: "time",
                prefix: "door_open_timeout_web_alert_delay",
                label: "Web Alert Delay",
                hint: "If Door Open Timeout continuously, web alert will be created after this amount of delay.",
            },
            {
                type: "time",
                prefix: "door_open_timeout_generic_notify_delay",
                label: "Generic Notification Delay",
                hint: "If Door Open Timeout continuously, generic notification will be sent after this amount of delay.",
            },
        ],
    },
    {
        id: "card_tamper_alert",
        title: "Card Tamper Alert",
        icon: "fa-solid fa-credit-card",
        fields: alertGroup("card_temper", {
            webHint: "If True, Card trigger will create Web Alert.",
            genericHint: "If True, Generic SMS alert will be sent.",
            alarmActive: true,
            alarmName: "card_temper_alarm_active",
            alarmHint: "If True, Device alarm will ring on Card Trigger.",
            durationPrefix: "card_temper_alarm_duration",
        }),
    },
    {
        id: "reader_fault",
        title: "Reader Fault Alert",
        icon: "fa-solid fa-microchip",
        fields: alertGroup("reader_fault", {
            webHint: "If True, Reader Fault will create Web Alert.",
            genericHint: "If True, Generic SMS alert will be sent.",
            alarmActive: true,
            alarmName: "reader_fault_alarm_active",
            alarmHint: "If True, Device alarm will ring on Reader Fault.",
            durationPrefix: "reader_fault_alarm_duration",
        }),
    },
];

export const getTimeFieldNames = (prefix) => {
    if (prefix === "door_open_timeout_open_time_") {
        return [
            "door_open_timeout_open_time_1",
            "door_open_timeout_open_time_2",
            "door_open_timeout_open_time_3",
        ];
    }
    return [`${prefix}1`, `${prefix}2`, `${prefix}3`];
};
